<template>

  <header class="plex-regular flex flex-col items-center justify-center bg-center md:bg-left-top bg-no-repeat">

    <div class="flex flex-col items-center w-full">

      <img class="object-contain w-11/12 md:w-7/12 lg:w-5/12 xl:w-4/12 md:py-0" src="@/assets/logo.png" />

      <!--div class="flex flex-col md:flex-row gap-2 md:gap-4 w-full px-4 text-center md:w-auto pb-10">
        <router-link to="/"
          class="px-5 py-2 border border-[#ff6235] bg-[#ff6235] text-white font-semibold hover:bg-white hover:text-[#ff6235] rounded-2xl">
          <i class="pi pi-user mr-2"></i>ACREDITARME
        </router-link>
        <router-link to="/credenciales"
          class="px-5 py-2 border border-[#ff6235] bg-[#ff6235] text-white font-semibold hover:bg-white hover:text-[#ff6235] rounded-2xl">
          <i class="pi pi-qrcode mr-2"></i>YA ME ACREDITÉ
        </router-link>


      </div-->

    </div>
  </header>

</template>

<script lang="ts">
import { defineComponent } from 'vue';
import VueScrollTo from 'vue-scrollto';

export default defineComponent({
  methods: {
    scrollToForm() {
      VueScrollTo.scrollTo('#formulario', 500, {
        easing: 'ease-in-out',
      });
    }

  },
});

</script>